"use strict";

module.exports = function () {
  var _global;
  return (_global = global).fetch.apply(_global, arguments);
};
//# sourceMappingURL=fetch.js.map